import { useCallback, useEffect, useState } from "react";
import { getUserById } from "../../../utils/apis/user-service";
import { useAuth } from "../../../utils/context/AuthContext";

export const useGetUserById = (userId: string | null) => {
    const { auth } = useAuth();
    const idToken = auth.idToken;
    const [user, setUser] = useState<any>(null);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState<string | null>(null);

    const fetchUser = useCallback(() => {
        if (!userId || !idToken) return;
        setIsLoading(true);
        setError(null);
        getUserById(userId, idToken)
            .then((user) => {
                setUser(user);
                setIsLoading(false);
            })
            .catch((err) => {
                setError("Errore nel recupero dell'utente");
                setIsLoading(false);
            });
    }, [userId, idToken]);

    useEffect(() => {
        fetchUser();
    }, [fetchUser]);

    return { user, isLoading, error, refetch: fetchUser };
}; 